'use client';

import { PostHogProvider as PHProvider } from '@posthog/react';
import { usePathname, useSearchParams } from 'next/navigation';
import posthog from 'posthog-js';
import { Suspense, useEffect } from 'react';

import { env } from '@/configs/env';

export function PostHogProvider({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    if (env.NEXT_PUBLIC_POSTHOG_PROJECT_TOKEN) {
      posthog.init(env.NEXT_PUBLIC_POSTHOG_PROJECT_TOKEN, {
        api_host: '/_nxh', // proxied in next.config.ts
        ui_host: env.NEXT_PUBLIC_POSTHOG_HOST.includes('eu.')
          ? 'https://eu.posthog.com'
          : 'https://us.posthog.com',
        person_profiles: 'identified_only',
        capture_pageview: false, // Handled by PostHogPageView
      });
    }
  }, []);

  return (
    <PHProvider client={posthog}>
      <Suspense fallback={null}>
        <PostHogPageView />
      </Suspense>
      {children}
    </PHProvider>
  );
}

function PostHogPageView() {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    if (pathname && posthog) {
      let url = window.origin + pathname;
      if (searchParams.toString()) {
        url = url + `?${searchParams.toString()}`;
      }
      posthog.capture('$pageview', {
        $current_url: url,
      });
    }
  }, [pathname, searchParams]);

  return null;
}
